//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import steps from "@/components/Steps";
import field from "@/components/UI/Field";
import {
    getStorage,
    setStorage,
    getThemeByType,
    getAppInfo,
    encrypt,
    BuildVersionDiff,
    getCookie,
    isWxMiniProgram,
    inLoanApp,
    isTTWebView,
    bankCardRegularCheck
} from "@/js/utils";
import { SUCCESS_CODE } from "@/service/httpCode";
import sendVerCodeBtn from "@/components/SendVerCodeBtn";
import loadFont from "@/js/loadFont";
import autoBindCard from "@/components/Repay/AutoBindCard";
import confirmBindCard from "@/components/Repay/ConfirmBindCard";
import bindCardProtocol from "@/components/Repay/BindCardProtocol";
import bankCardCompliance from "@/components/BankCardCompliance";
import OcrMethodDialog from "@/components/LoanBindCard/OcrMethodDialog";
import ocrMixins from "@/mixins/ocr";

export default {
    name: "loanbindcard",
    components: {
        steps,
        field,
        sendVerCodeBtn,
        autoBindCard,
        confirmBindCard,
        bindCardProtocol,
        bankCardCompliance,
        OcrMethodDialog
    },
    data() {
        return {
            isLoading: false,
            bankcardnum: "",
            currentBank: "",
            mobile: "",
            vercode: "",
            isShowCurrentBank: false,
            isShowMobile: false,
            isShowVercode: false,
            realname: "",
            isCallOCRBtnDisabled: false,
            isNextDisabled: false,
            showHeight: document.documentElement.clientHeight,
            docHeight: document.documentElement.clientHeight,
            showBtn: true,
            cebankList: [],
            showConfirmDialog: false,
            bindCardInitData: {},
            quickTradeId: "",
            showJumpDialog: false,
            isProtocolChecked: false,
            showProtocolDialog: false,
            formData: {
                action: "",
                params: [],
            },
            canPollingResult: true, // 控制页面是否需要轮询结果
            currentBankId: "",
            listenerServiceDone: false,
            cemode: 1,
            widgetThemeType: false,
            selectedShow: true,
            contentShow: true,
            protocolSelected: false,
            isShowOCR: false,
            isOcrMethodShow: false,
            ocrTag: 0,
            bindCardMethod: 0, // 绑卡方式，0；手动输入，1：OCR，2：本地识别，3：一键绑卡
            smsTradeID: ''
        };
    },
    mixins: [ocrMixins],
    watch: {
        currentBank() {
            this.isShowMobile = !!this.currentBank;
            setTimeout(() => {
                this.$refs.currentBank.validField();
            }, 100);
        },
        mobile(val) {
            if (
                this.bindType === "normal" &&
                !this.isShowVercode &&
                val.length === 11
            ) {
                this.$nextTick(() => {
                    if (this.$refs.mobile.validField()) {
                        this.isShowVercode = true;
                    }
                    this.sensorsRecord("h5_element_imp", {
                        tgt_event_id: "h5_paycash_loanbindcard_show_vercode",
                        tgt_name: "h5-paycash-戳额绑卡页-展示验证码输入框",
                        url: location.href,
                        page: "戳额绑卡页",
                        param4: this.isShowVercode,
                    });
                });
            }
        },
        isShowMobile() {
            if (!this.isShowMobile) {
                this.mobile = "";
                this.isShowVercode = false;
            }
        },
        vercode(val) {
            if (val.length === 6) {
                this.sendRecord("560");
                this.sensorsTrack("h5_element_imp", {
                    tgt_event_id: "h5_paycash_syt_560",
                    tgt_name: "h5-paycash-戳额绑卡页-输入验证码",
                });
            }
        },
        showHeight() {
            if (this.isAndroid) {
                this.showBtn = this.docHeight <= this.showHeight;
            }
        },
    },
    computed: {
        isIphoneX() {
            return (
                (screen.height === 812 || screen.height === 896) &&
                screen.width === 375
            );
        },
        originBankNum() {
            return this.bankcardnum.replace(/\s/g, "");
        },
        bindType() {
            // normal 正常绑卡，auto 一键绑卡
            return this.originBankNum.includes("*") && this.mobile.includes("*")
                ? "auto"
                : "normal";
        },
        bgWidgetThemeType() {
            return (
                this.widgetThemeType &&
                this.$widgetTheme &&
                this.$widgetTheme.p1 == "#3A90C2"
            );
        },
    },
    activated() {
        this.showAppTitle();
        this.currentBank = this.$store.selectedBank || "";
    },
    filters: {
        subStr: function (str) {
            if (str.length > 5) {
                str = str.substring(0, 5) + "...";
            }
            return str;
        },
    },
    async created() {
        loadFont();
        this.showAppTitle();

        const { system } = getAppInfo();
        this.isAndroid = system === "android";

        if (inLoanApp()) {
            const [version, firstVer, secondVer, thirdVer] =
                window.PPDWebUI.os.buildVersion.match(/(\d+)\.(\d+)\.(\d+)/);
            // 借款版本大于等于9.0.0才能支持一键绑卡
            this.isAutoBindCardSupport =
                parseInt(
                    firstVer +
                    secondVer.padStart(2, "0") +
                    thirdVer.padStart(2, "0")
                ) >= 90000;
            this.isCmbInstalled = false;
            // 换肤版本控制
            this.widgetThemeType = BuildVersionDiff("9.2.0");
            if (this.isAutoBindCardSupport) {
                this.isCmbInstalled = await this.judgeCmbIsInstalled();
            }
        }
        this.showTheLoading(async () => {
            const { appId, bizCode, orderType } = this.$store;
            const { jumpType } = this.$route.query;
            this.sendRecord("1009");

            this.orderNo = this.$store.orderNo;
            const { data, result } = await this.$http.ceBindcardLoad(
                this.$store.orderNo
            );
            const {
                cebankList,
                bankList,
                quickTradeId,
                copyWritingTag,
                protocolTag,
                ocrTag,
            } = data;
            if (result === SUCCESS_CODE) {
                if (
                    this.isAutoBindCardSupport &&
                    cebankList &&
                    cebankList.length > 0
                ) {
                    cebankList.forEach((bankInfo) => {
                        // 目前H5是全量支持的
                        this.cebankList.push(bankInfo);

                        // if (bankInfo.bankName === "招商银行") {
                        //     if (this.isCmbInstalled) {
                        //         this.cebankList.push(bankInfo);
                        //     }
                        // } else if (
                        //     (bankInfo.bankID == "5" ||
                        //         bankInfo.bankID == "13") &&
                        //     BuildVersionDiff("9.2.10")
                        // ) {
                        //     this.cebankList.push(bankInfo);
                        // } else {
                        //     this.cebankList.push(bankInfo);
                        // }
                        // if (bankInfo.bankID == "5") {
                        //     this.cemode = bankInfo.cemode || 1;
                        // }
                    });
                }

                this.bindCardInitData = data;
                this.isProtocolChecked = data.agreeMent === 1;

                this.quickTradeId = quickTradeId;

                this.banks = bankList || [];
                setStorage("session", "banks", this.banks);

                this.contentShow =
                    copyWritingTag === null ? true : copyWritingTag;
                this.selectedShow = protocolTag === null ? true : protocolTag;

                // 灰度展示OCR功能
                this.ocrTag = ocrTag || 0;

                this.isShowOCR =
                    inLoanApp() &&
                    BuildVersionDiff("9.21.0") && this.ocrTag != 0;

                // this.isShowOCR =
                //     inLoanApp() &&
                //     BuildVersionDiff("9.21.0") &&
                //     (ocrTag === 3 ||
                //         (this.isAndroid ? ocrTag === 2 : ocrTag === 1));

                this.sensorsRecord("h5_element_imp", {
                    tgt_event_id: "h5_paycash_loanbindcard_pageview",
                    tgt_name: "h5-paycash-戳额绑卡页-页面曝光",
                    url: location.href,
                    page: "戳额绑卡页",
                    param4: this.isShowOCR,
                    param5: this.cebankList.length > 0,
                    param6: this.ocrTag,
                });

                this.$bus.$emit("update-title", {
                    hasHeader: false,
                });

                if (jumpType === "h5") {
                    await this.pollingResult();
                    this.sendRecord("1023");
                }
            }
        }, "isLoading");
    },
    mounted() {
        if (this.isAndroid) {
            this.resize = () => {
                return (() => {
                    this.showHeight = document.body.clientHeight;
                })();
            };
            window.addEventListener("resize", this.resize, false);
        }
    },
    methods: {
        applyBindCard(quickBindParams) {
            // this.showJumpDialog = true;
            this.quickBindParams = quickBindParams;
            this.canPollingResult = true;
            this.currentBankId = quickBindParams.bankId;

            this.handleSelected(true);

            // 标记当前流程
            this.bindCardMethod = 3;

            // 一键绑卡申请
            this.quickBindApply(this.quickBindParams);
        },
        beforeJumpDialogClose(action, done) {
            if (action === "confirm") {
                this.sendRecord("1015");
                if (!this.isProtocolChecked) {
                    this.$toast("请阅读并勾选《授权协议》");
                    done(false);
                } else {
                    this.quickBindApply(this.quickBindParams);
                    done();
                }
            } else {
                this.sendRecord("1014");
                done();
            }
        },
        closeProtocol() {
            this.showProtocolDialog = false;
            this.sendRecord("1018");
        },
        clickProtocol() {
            this.showProtocolDialog = true;
            this.sendRecord("1013");
        },
        closeConfirmDialog() {
            this.showConfirmDialog = false;
            this.sendRecord("1020");
        },
        clearTimer() {
            clearInterval(this.queryTimer);
            clearTimeout(this.timer);
        },
        async pollingResult() {
            this.$vux.loading.show();
            this.isQuickBindTrigger = false;
            const data = await this.quickBindProcessing();

            if (this.statusCode === 1) {
                this.$toast("快捷绑卡成功");

                this.sensorsTrack("h5_clk", {
                    tgt_event_id: "h5_paycash_second_sign",
                    tgt_name: "h5-paycash-戳额绑卡页-是否二次签约",
                    param4: data.secSign,
                })

                if (data.secSign === 1) {
                    this.$vux.loading.show();
                    // 需要二次签约
                    // this.showConfirmDialog = true;
                    const { phone, cardNum, bankId, quickTradeId } = data;
                    this.bankcardnum = cardNum;
                    this.currentBank = bankId;
                    this.$store.selectedBank = bankId;
                    this.isShowCurrentBank = true;
                    this.quickTradeId = quickTradeId;
                    this.mobile = phone;

                    try {
                        const smsResult = await this.doRequest('cesendSms', {
                            orderNum: this.orderNo,
                            quickTradeId: this.quickTradeId
                        });
                        this.$vux.loading.hide();

                        this.smsTradeID = smsResult.tradeID;
                        this.showConfirmDialog = true;

                        this.sensorsTrack("h5_clk", {
                            tgt_event_id: "h5_paycash_send_sms_success",
                            tgt_name: "h5-paycash-戳额绑卡页-发送短验成功",
                            param4: this.smsTradeID,
                        })
                    } catch (e) {
                        this.$vux.loading.hide();
                        this.sensorsTrack("h5_clk", {
                            tgt_event_id: "h5_paycash_send_sms_error",
                            tgt_name: "h5-paycash-戳额绑卡页-发送短验异常",
                            param4: JSON.stringify(e),
                            param5: this.bindCardInitData.returnUrl,
                        })
                        // 接口异常，直接跳转业务方地址
                        location.href = this.bindCardInitData.returnUrl;
                    }
                } else {
                    this.sensorsTrack("h5_clk", {
                        tgt_event_id: "h5_paycash_no_need_sign",
                        tgt_name: "h5-paycash-戳额绑卡页-无需二次签约",
                        param4: this.bindCardInitData.returnUrl,
                    })
                    // 不需要二次签约，直接跳转业务方地址
                    location.href = this.bindCardInitData.returnUrl;
                }
            }
            this.$vux.loading.hide();
            if (this.statusCode !== 1) {
                this.$toast(data.resultMsg);
            }
        },
        quickBindProcessing() {
            return new Promise((resolve) => {
                const seconds = this.bindCardInitData.quickQuerySeconds
                    ? this.bindCardInitData.quickQuerySeconds * 1000
                    : 10000;
                this.clearTimer();
                this.queryBindResult(resolve);
                this.timer = setTimeout(() => {
                    this.clearTimer();
                    this.isQuickBindTrigger = true;

                    if (this.statusCode !== 1) {
                        resolve();
                    }
                }, seconds);
                this.queryTimer = setInterval(async () => {
                    this.queryBindResult(resolve);
                }, 1000);
            });
        },
        async queryBindResult(resolve) {
            const data = await this.doRequest("cequeryQuickBindResult", {
                quickTradeId: this.quickTradeId,
            });
            this.statusCode = data.statusCode;
            if (data.statusCode != 0) {
                this.clearTimer();
                resolve(data);
            }
        },
        async quickBindApply({ type, bankId }) {
            this.$vux.loading.show();
            // 判断从外部回来是否点击过一键绑卡，避免没必要的轮询出现
            this.isQuickBindTrigger = true;

            try {
                const data = await this.doRequest("cequickBind", {
                    orderNum: this.$store.orderNo,
                    bankId,
                    returnUrl: `https://m.ppdai.com/?page#1009`,
                });
                this.$vux.loading.hide();
                const { quickTradeId, resultParam, method, submitUrl } = data;
                if (!resultParam || !submitUrl) {
                    return this.$toast("跳转银行签约失败，请重新签约");
                }
                if (type === 1) {
                    /// 清理
                    this.bankcardnum = "";
                    this.mobile = "";

                    this.quickTradeId = quickTradeId;
                    const { href } = this.$router.resolve({
                        path: `/BindCardMiddlePage`,
                        query: {
                            submitUrl: submitUrl,
                            resultParam: resultParam,
                        },
                    });
                    if (!this.listenerServiceDone) {
                        this.listenerServiceDone = true;
                        window.PPDWebUI.ListenerService.resumeListener(
                            async () => {
                                if (this.isQuickBindTrigger) {
                                    this.sendRecord("1023");
                                    await this.pollingResult();
                                }
                            }
                        );
                    }
                    window.PPDWebUI.CommonService.openUrl(
                        {
                            url: location.origin + href,
                        },
                        function () { },
                        function () { }
                    );

                    // h5方式跳页面
                    // location.href = resultParam
                    // if (method === "GET") {
                    //     location.href = resultParam;
                    // } else {
                    //     this.formData.action = submitUrl;
                    //     let data = JSON.parse(resultParam);
                    //     let params = [];
                    //     for (let key of Object.keys(data)) {
                    //         params.push({ name: key, value: data[key] });
                    //     }
                    //     this.formData.params = params;
                    //     this.$nextTick(() => {
                    //         if (this.currentBankId == "5" && this.cemode == 2) {
                    //             this.quickTradeId = quickTradeId;
                    //             const { href } = this.$router.resolve({
                    //                 path: `/BindCardMiddlePage`,
                    //                 query: {
                    //                     submitUrl: submitUrl,
                    //                     resultParam: resultParam,
                    //                 },
                    //             });
                    //             if (!this.listenerServiceDone) {
                    //                 this.listenerServiceDone = true;
                    //                 PPDWebUI.ListenerService.resumeListener(
                    //                     async () => {
                    //                         if (this.isQuickBindTrigger) {
                    //                             this.sendRecord("1023");
                    //                             await this.pollingResult();
                    //                         }
                    //                     }
                    //                 );
                    //             }
                    //             PPDWebUI.CommonService.openUrl(
                    //                 {
                    //                     url: location.origin + href,
                    //                 },
                    //                 function () { },
                    //                 function () { }
                    //             );
                    //         } else {
                    //             this.$bus.$emit("update-title", {
                    //                 title: "开通快捷支付",
                    //                 noClose: true,
                    //             });
                    //             this.$refs.submitBtn.click();
                    //         }
                    //     });
                    // }
                } else {
                    // app方式打开银行app
                    this.quickTradeId = quickTradeId;

                    window.PPDWebUI.ListenerService.resumeListener(() => {
                        // 轮询结果
                        if (this.isQuickBindTrigger && this.canPollingResult) {
                            this.sendRecord("1023");
                            this.pollingResult();
                        }
                    });
                    this.bankcardnum = "";
                    this.mobile = "";
                    const bankUrl = `cmbmobilebank://cmbls/functionjump?action=gofuncid&funcid=0026014&requesttype=post&cmb_app_trans_parms_start=here&epccGwMsg=${resultParam}`;
                    window.PPDWebUI.AppLinkService.launchApp(
                        {
                            data: bankUrl,
                        },
                        () => { },
                        (e) => {
                            this.$vux.toast.show({
                                type: "text",
                                text: "跳转招行失败了",
                                width: "50%",
                            });
                        }
                    );
                }
            } catch (e) {
                this.$vux.loading.hide();
            }
        },
        // 判断招商银行是否安装
        async judgeCmbIsInstalled() {
            return new Promise((resolve, reject) => {
                const packageName = this.isAndroid
                    ? "cmb.pb"
                    : "cmbmobilebank://cmbls/functionjump";
                window.PPDWebUI.AppLinkService.checkInstalled(
                    {
                        packageName,
                    },
                    (result) => {
                        if (result === "1") {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    },
                    (e) => {
                        this.$vux.toast.show({
                            type: "text",
                            text: "调用sdk报错了",
                            width: "50%",
                        });
                        reject();
                    }
                );
            });
        },
        mobileBlur() {
            if (
                this.bindType === "normal" &&
                this.mobile &&
                this.mobile.length === 11
            ) {
                // 新增兜底展示逻辑
                if (!this.isShowVercode && this.$refs.mobile.validField()) {
                    this.isShowVercode = true;
                }
                this.sendRecord("1004");
            }
        },
        next() {
            this.sendRecord("1007");
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_loanbindcard_button",
                tgt_name: "h5-paycash-戳额绑卡页-确认绑卡按钮",
                url: location.href,
                page: "戳额绑卡页",
                param4: this.bindType,
                param5: this.currentBank,
                param6: this.bindCardMethod,
            });
            if (this.bindType === "auto") {
                this.showConfirmDialog = true;
            } else {
                const { bankcard, currentBank, mobile, vercode } = this.$refs;
                if (
                    (bankcard && !bankcard.validField()) ||
                    (currentBank && !currentBank.validField()) ||
                    (mobile && !mobile.validField()) ||
                    (vercode && !vercode.validField())
                )
                    return;

                if (!this.protocolSelected && this.selectedShow) {
                    return this.$toast("请阅读并勾选协议");
                }

                this.isNextDisabled = true;
                this.showTheLoading(async () => {
                    if (
                        this.isShowOCR &&
                        this.originBankNum == this.identifiedCardNum
                    ) {
                        // 识别出来的卡号和提交的卡号一致
                        this.sensorsTrack("h5_element_imp", {
                            tgt_event_id:
                                "h5_paycash_loanbindcard_bankcard_consistent",
                            tgt_name: "h5-paycash-戳额绑卡页-银行卡号一致",
                        });
                    }

                    let params = {
                        orderNum: this.orderNo,
                        tradeID: this.tradeID,
                        verifyCode: this.vercode,
                    };
                    const { result, resultMessage } =
                        await this.$http.bindcardApply(params);
                    if (result === SUCCESS_CODE) {
                        // 绑卡成功埋点
                        this.sendRecord("1042", this.bankcardnum);
                        this.sendRecord("1043", this.currentBank);

                        this.sensorsRecord("h5_element_imp", {
                            tgt_event_id:
                                "h5_paycash_loanbindcard_apply_success",
                            tgt_name: "h5-paycash-戳额绑卡页-绑卡成功",
                            url: location.href,
                            page: "戳额绑卡页",
                            param4: this.currentBank,
                            param5: this.bindCardMethod,
                        });

                        if (isWxMiniProgram() || isTTWebView()) {
                            // uni && uni.navigateBack();
                            uni &&
                                uni.redirectTo({
                                    url: `/pages/common/webview?url=${encodeURIComponent(
                                        this.bindCardInitData.returnUrl
                                    )}&openType=auth`,
                                });
                        } else {
                            location.href = this.bindCardInitData.returnUrl;
                        }
                        this.sendRecord("1011");
                    } else {
                        this.isBindCardError = true;
                        if (resultMessage) {
                            this.sensorsRecord("h5_element_imp", {
                                tgt_event_id:
                                    "h5_paycash_loanbindcard_apply_resultmsg",
                                tgt_name:
                                    "h5-paycash-戳额绑卡页-确认绑卡Apply结果信息",
                                url: location.href,
                                page: "戳额绑卡页",
                                param4: resultMessage,
                                param5: this.currentBank,
                                param6: this.bindCardMethod,
                            });
                        }
                    }
                });
                this.isNextDisabled = false;
            }
        },
        showAppTitle() {
            window.PPDWebUI.CommonService.setNavigation(
                {
                    visible: "1",
                    fullScreen: "2",
                    leftView: [
                        {
                            action: "back",
                            icon: "ppdwebui://resource/drawable/nav_back",
                        },
                    ],
                    titleView: {
                        text: "额度申请",
                    },
                },
                function () { },
                function (err) { }
            );
        },
        close() {
            this.sendRecord("1008");
            window.PPDWebUI.CommonService.close(
                {},
                () => { },
                () => { }
            );

            if (this.isBindCardError) {
                this.sendRecord("1010");
            }
        },
        // callOCR(type) {
        //     const ocrMethod = type ? type : this.ocrTag;

        //     if (ocrMethod === 1) {
        //         // OCR扫描识别
        //         this.OcrNative();
        //     } else if (ocrMethod === 2) {
        //         // 手机相册识别
        //         this.OcrApi();
        //     } else {
        //         this.isOcrMethodShow = !type;
        //     }
        // },
        goToSupportBank() {
            this.sendRecord("1003");
            this.$router.push({ name: "banks" });
        },
        async checkCardBin() {
            if (this.bindType === "normal") {
                this.sendRecord("1001");

                if (this.bankcardnum.length > 11 && bankCardRegularCheck(this.bankcardnum)) {
                    this.sensorsTrack("h5_element_imp", {
                        tgt_event_id: "h5_paycash_syt_1001",
                        tgt_name: "h5-paycash-戳额绑卡页-输入银行卡号",
                    });

                    const { data, result } = await this.$http.queryCardBin({
                        cardNum: encrypt(this.originBankNum),
                        orderNum: this.orderNo,
                    });
                    if (result === SUCCESS_CODE && data) {
                        this.sendRecord("530", this.bankcardnum);
                        this.currentBank = data.bankID;
                        this.$store.selectedBank = data.bankID;
                    } else {
                        this.currentBank = "";
                        this.$store.selectedBank = "";
                    }
                    this.isShowCurrentBank = true;
                } else {
                    this.currentBank = "";
                    this.isShowCurrentBank = false;
                    this.$store.selectedBank = "";
                }
            }
        },
        async sendVertificationCode() {
            this.sendRecord("550");
            const { data, result } = await this.$http.sendSms({
                bankID: this.currentBank,
                cardNum: encrypt(this.originBankNum),
                mobile: encrypt(this.mobile),
                orderNum: this.orderNo,
            });
            if (result === SUCCESS_CODE) {
                this.tradeID = data.tradeID;
            }
            return result;
        },
        handleSelected(value) {
            this.protocolSelected = value;
        },
        sensorsTrack(eventType, params) {
            this.sensorsRecord(eventType, Object.assign({
                url: location.href,
                page: "戳额绑卡页",
            }, params));
        }
    },
    destroyed() {
        if (this.isAndroid) {
            window.removeEventListener("resize", this.resize, false);
        }
    },
};
